import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {quat2} from 'gl-matrix';

const _tempTransform = quat2.create();
/**
 * head
 */
export class Head extends Component {
    static TypeName = 'head';

    /* Properties that are configurable in the editor */

    @property.object()
    nonVrCamera: Object3D | null = null;

    @property.object()
    EyeLeft: Object3D | null = null;

    @property.object()
    EyeRight: Object3D | null = null;

    start(): void {
        this.nonVrCamera =
            this.nonVrCamera || this.object!.parent!.findByNameDirect('nonVrCamera');
        this.EyeLeft = this.EyeLeft || this.object!.parent!.findByNameDirect('EyeLeft');
        this.EyeRight = this.EyeRight || this.object!.parent!.findByNameDirect('EyeRight');
    }

    update(dt: number) {
        // /* Called every frame. */
        // if (!this.nonVrCamera || !this.EyeLeft || !this.EyeRight) return;
        // if (!this.engine.xr) {
        //     this.object!.setTransformWorld(
        //         this.nonVrCamera.getTransformWorld(_tempTransform)
        //     );
        // } else {
        //     this.object!.setTransformWorld(this.EyeLeft.getTransformWorld(_tempTransform));
        // }
    }
}
